import {Button as BaseButton, Spinner} from "@ui-kitten/components";
import {Keyboard, Text, View} from "react-native";
import * as React from "react";
import {TouchableWithoutFeedback} from "react-native";

const buttonStyle = (loading, onWhite, mainColor = '#a0c946') => {
    const backgroundColor = loading ? mainColor : 'transparent'

    const borderColor = mainColor

    const color = loading ? backgroundColor : (
        onWhite ? mainColor : 'white'
    )

    return {borderWidth: 1, backgroundColor, borderColor, overflow: 'hidden', height: 26, borderRadius: 13, color, paddingLeft: 20, paddingRight: 20, paddingBottom: 2, paddingTop: 2 }
}

export const Button = ({ mainColor, onWhite, loading, children, ...restProps }) => <TouchableWithoutFeedback onPress={() => {
    Keyboard.dismiss();
    restProps.onPress()
}}>
    <View style={{alignItems: 'center'}}>
        {loading && <View style={{position: 'absolute', zIndex: 1, marginTop: 1}}><Spinner status='basic' /></View>}
        <Text style={buttonStyle(loading, onWhite, mainColor )}>
            {children}
        </Text>
    </View>
</TouchableWithoutFeedback>